export const sortFieldOptions = [
    { label: 'Productiedatum', value: 'productiondate' },
    { label: 'Productnr', value: 'productnr' },
    { label: 'Prositenr', value: 'prositenr' },
    { label: 'Ordernr', value: 'ordernr' },
    { label: 'Klant', value: 'customer' },
    { label: 'Referentie', value: 'reference' },
    { label: 'Producttype', value: 'producttype' },
    { label: 'Productgroep', value: 'productgroup' },
    { label: 'Productsubgroep', value: 'productsubgroup' },
    { label: 'Leverancier', value: 'supplier' },
];
export const sortOrderOptions = [
    { label: 'Oplopend', value: 'ASC' },
    { label: 'Aflopend', value: 'DESC' },
];
export const specialFilterOptions = [
    { label: 'Geen filter', value: 'noFilter' },
    { label: 'In buffertijd', value: 'pastDueFilter' },
    { label: 'Aangepaste leverdatum', value: 'recalculatedFilter' },
    { label: 'Toon ook afgewerkte producten', value: 'finishedFilter' },
    { label: 'Groothandel klanten', value: 'eosolFilter' },
    { label: 'Particuliere klanten', value: 'mmFilter' },
];

export const clearedFilters = {
    productNr: '',
    prositeId: '',
    orderId: '',
    customerName: '',
    reference: '',
    dimensions: '',
    productionDate: '',
    //boxnr: '',
    colli: '',
    sortField: sortFieldOptions[0].value,
    sortOrder: sortOrderOptions[0].value,
    specialFilter: specialFilterOptions[0].value,
    producttypeName: '0',
    profileGroupName: '0',
    profileSubgroupName: '0',
    supplierName: '0',
    stockLocation1: null,
    stockLocation2: null,
    stockLocation3: null,
};
